import React from 'react';
import PropTypes from 'prop-types';

const CaretLeftIcon = ({ color = 'black ' }) => {
    return (
        <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
                d="M9.5 3.5L5 8L9.5 12.5"
                stroke={color}
                strokeMiterlimit="10"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
        </svg>
    );
};

CaretLeftIcon.propTypes = {
    color: PropTypes.string,
};

export default CaretLeftIcon;
